export const sanitizeFileName = (fileName) => {
    let preSanitizedFileName = fileName.replace(/[\u200B-\u200D\uFEFF]/g, ""); // Remove invisible characters
    preSanitizedFileName = preSanitizedFileName
        .replace(/á|Á/g, "a")
        .replace(/é|É/g, "e")
        .replace(/í|Í/g, "i")
        .replace(/ó|Ó/g, "o")
        .replace(/ú|Ú|ü|Ü/g, "u")
        .replace(/ñ|Ñ/g, "n")
        .replace(/[^a-zA-Z0-9.\-_ ]/g, ""); // Remove other special characters
    const encodedFileName = encodeURIComponent(preSanitizedFileName);
    const nFileName = encodedFileName.replace("%E2%80%AF", " ");
    return decodeURIComponent(nFileName);
};